import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fastPercentage", "smartPercentage", "smartToggle"];

  connect() {
    this.toggleSmartPercentage();
  }

  toggleSmartPercentage() {
    if (this.hasSmartPercentageTarget) {
      this.smartPercentageTarget.disabled = this.isFast();
    }

    if (this.isFast() && this.hasFastPercentageTarget && this.hasSmartPercentageTarget) {
      this.fastPercentageTarget.value = this.smartPercentageTarget.value;
    }
  }

  isSmart() {
    return this.hasSmartToggleTarget ? this.smartToggleTarget.checked : false;
  }

  isFast() {
    return !this.isSmart();
  }

  copyPercentageIfFast() {
    if (this.isFast() && this.hasSmartPercentageTarget && this.hasFastPercentageTarget) {
      this.smartPercentageTarget.value = this.fastPercentageTarget.value;
    }
  }
}
